module.exports = __webpack_public_path__ + "static/media/select_from_map.58f62d6b.svg";